/**
 * See also @wandb/weave/common/components/EditableField
 */

import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import * as S from './EditableName.styles';

type EditableNameProps = {
  content: string;
  onRename: (newName: string) => void;
};

export const EditableName = ({content, onRename}: EditableNameProps) => {
  const [value, setValue] = useState(content);
  const [isEditing, setIsEditing] = useState(false);
  const onEdit = () => {
    setIsEditing(!isEditing);
  };
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };
  const onBlur = () => {
    setIsEditing(false);
    // TODO: Should we be checking whether the name has changed?
    onRename(value);
  };
  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onBlur();
    }
  };

  return (
    <S.CenteredFlex>
      <S.Value>
        {isEditing ? (
          <S.Input
            autoFocus
            onChange={onChange}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            value={value}
          />
        ) : (
          value
        )}
      </S.Value>
      {!isEditing && (
        <Button
          icon="pencil-edit"
          variant="ghost"
          onClick={onEdit}
          tooltip="Edit job name"
          style={{marginLeft: '8px'}}
        />
      )}
    </S.CenteredFlex>
  );
};
